document.addEventListener("DOMContentLoaded", function() {
  // Step 1: Identify Variant Change Event
  var variantSelect = document.querySelector('.product-detail__form__options select');

  if (variantSelect) {
    variantSelect.addEventListener('change', function(event) {
      var selectedOptionText = event.target.options[event.target.selectedIndex].text;

      // Step 2: Mapping Variant to Colors
      var colorMapping = {
        "Green": "green",
        "Beige": "beige",
        // ... (add more mappings here based on your product variants)
      };
      
      // Step 3: Change Background Color
      updateBackgroundColor(selectedOptionText, colorMapping);
    });
  }

  function updateBackgroundColor(selectedOption, colorMapping) {
    console.log('Variant changed to:', selectedOption); // Debug line
    var body = document.querySelector('body');

    // Step 4: Fallback Mechanism
    body.style.backgroundColor = colorMapping[selectedOption] || "white"; // Fallback to white if the variant is not in the mapping
  }
});
